import React, { Component, Fragment } from 'react';

import { Glyphicon } from 'react-bootstrap';
import { connect } from 'react-redux';
import '../styles/containers/Orders.css';
import InfiniteSccroll from 'react-infinite-scroller';
import { AxiosError } from 'axios';

import * as Service from '../services/OrdersService';
import { setFilterData, setFilterFlag } from '../actions/ordersActions';
import OrdersList from '../components/orders/OrdersList';
import TopPanel from '../components/utils/TopPanel';
import {
  generateKeyStr,
  isMobileResolution,
  openLink,
} from '../infrastructure/utils/common';
import TableSortingElem from '../infrastructure/TableSorting';
import OrderFilterForm from '../components/forms/OrderFilterForm';
import Spinner from '../components/utils/Spinner';
import MobileTopPanelActions from '../components/utils/MobileTopPanelActions';
import MobileListSorter from '../components/utils/MobileListSorter';
import { mapFromOrderToOrderCSV } from '../infrastructure/utils/orders';

const initialState = {
  ordersLoaded: false,
  allorders: false,
  isDeactive: false,
  noData: false,
  orders: null,
  token: null,
  listKey: generateKeyStr(),
  avaliableSort: [],
  activeSort: undefined,
  filterData: undefined,
  openModal: false,
  firstLoad: true,
  isMobileFilterSelected: false,
  isMobileSortSelected: false,
  csvOrders: [],
};

class Orders extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  async componentDidMount() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { filterData, activeFilter, activateFilter } = this.props;
    const defaultFilter = {
      status: 'Pending',
      fromDate: '',
      toDate: '',
      name: '',
    };
    document.documentElement.style.overflow = 'hidden';
    if (activeFilter) {
      this.loadFirstOrders(filterData);
      activateFilter(false);
    } else {
      this.loadFirstOrders(defaultFilter);
    }
  }

  componentWillUnmount() {
    document.documentElement.style.overflow = 'auto';
    this.setState({ deactive: true });
  }

  loadFirstOrders = async filterData => {
    this.loadOrders({
      token: null,
      firstLoad: true,
      filterData,
      order: new TableSortingElem({
        name: 'startDateTime',
        up: true,
      }),
    });
  };

  handleOrderClick = (event, url) => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { filterData } = this.state;
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { history, setFilter, activateFilter } = this.props;
    setFilter(filterData);
    activateFilter(true);
    openLink(event, url, history, !isMobileResolution());
  };

  loadCSVOrders = async () =>
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line no-async-promise-executor
    new Promise(async (resolve, reject) => {
      try {
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        const { activeSort, filterData } = this.state;
        const data = await Service.getAllOrders(
          activeSort,
          filterData,
          0,
          true
        );
        const csvOrders = data.map(mapFromOrderToOrderCSV);
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        this.setState({ csvOrders }, () => resolve());
      } catch (e) {
        console.log(e);
        const error = e as AxiosError;
        alert(
          `Error code: ${error?.response?.status} \nError message: ${error?.response?.data}`
        );
        reject();
      }
    });

  loadMoreOrders = async () => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { token, activeSort, filterData } = this.state;
    this.loadOrders({ token, firstLoad: false, order: activeSort, filterData });
  };

  loadOrders = async ({ token, firstLoad, order, filterData }) => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const data = await Service.getAllOrders(order, filterData, token);
    if ((data || []).length === 0) {
      if (firstLoad) {
        this.setState({ orders: [] });
      }
      this.setState({ allOrders: true });
      return;
    }
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { deactive } = this.state;
    if (!deactive) {
      if (firstLoad) {
        this.setState({
          orders: data,
          token: 25,
          avaliableSort: [
            new TableSortingElem({
              name: 'customer.memberName',
              isString: true,
              up: true,
              label: 'Customer Name',
            }),
            new TableSortingElem({
              name: 'customer.memberName',
              isString: true,
              up: false,
              label: 'Customer Name',
            }),
            new TableSortingElem({
              name: 'activity.vendorName',
              isString: true,
              up: true,
              label: 'Vendor Name',
            }),
            new TableSortingElem({
              name: 'activity.vendorName',
              isString: true,
              up: false,
              label: 'Vendor Name',
            }),
            new TableSortingElem({
              name: 'totalPrice',
              isString: true,
              up: true,
              label: 'Total Price',
            }),
            new TableSortingElem({
              name: 'totalPrice',
              isString: true,
              up: false,
              label: 'Total Price',
            }),
            new TableSortingElem({ name: 'status', isString: true, up: true }),
            new TableSortingElem({ name: 'status', isString: true, up: false }),
            new TableSortingElem({ name: 'created', up: true }),
            new TableSortingElem({ name: 'created', up: false }),
            new TableSortingElem({
              name: 'name',
              isString: true,
              up: true,
              label: 'Order Name',
            }),
            new TableSortingElem({
              name: 'name',
              isString: true,
              up: false,
              label: 'Order Name',
            }),
            new TableSortingElem({
              name: 'startDateTime',
              up: true,
              label: 'Start Date Time',
            }),
            new TableSortingElem({
              name: 'startDateTime',
              up: false,
              label: 'Start Date Time',
            }),
          ],
          activeSort: order,
          filterData,
          listKey: generateKeyStr(),
          allOrders: false,
          ordersLoaded: true,
        });
      } else {
        this.setState(state => ({
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          orders: state.orders.concat(data),
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          token: state.token + 25,
        }));
      }
    }
  };

  getFilteredOrders = async filterData => {
    this.setState({ filterData });
    this.loadFirstOrders(filterData);
  };

  changeSort = name => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { activeSort, avaliableSort, filterData } = this.state;
    let sort = null;
    if (activeSort.name === name) {
      sort = {
        ...activeSort,
        up: !activeSort.up,
      };
      this.setState({ activeSort: sort });
    } else {
      sort = avaliableSort.find(s => s.name === name);
    }
    this.loadOrders({ token: null, firstLoad: true, order: sort, filterData });
  };

  changeSortBySelect = (name, up) => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { avaliableSort, filterData } = this.state;
    const sort = avaliableSort.find(s => s.name === name);
    if (!sort) return;
    sort.up = up;
    this.setState({ activeSort: sort });
    this.loadOrders({ token: null, firstLoad: true, order: sort, filterData });
  };

  removeFilter = () => {
    this.setState({ filterData: undefined });
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    this.loadFirstOrders();
  };

  render() {
    const {
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      ordersLoaded,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      orders,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      allOrders,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      avaliableSort,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      activeSort,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      listKey,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      filterData,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      isMobileFilterSelected,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      isMobileSortSelected,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      csvOrders,
    } = this.state;
    if (!ordersLoaded) {
      return <Spinner />;
    }

    return (
      <Fragment>
        <TopPanel>
          <h1
            className='col-md-6 col-sm-4 col-xs-3'
            style={{ marginTop: '0px', paddingLeft: '29px' }}
          >
            <span className='fas fa-beer' /> Orders
          </h1>
          {
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            <MobileTopPanelActions
              isFilterSelected={isMobileFilterSelected}
              isSortSelected={isMobileSortSelected}
              onFilterClick={() =>
                this.setState({
                  isMobileFilterSelected: !isMobileFilterSelected,
                })
              }
              onSortClick={() =>
                this.setState({ isMobileSortSelected: !isMobileSortSelected })
              }
            />
          }
        </TopPanel>
        <div className='data-container'>
          <OrderFilterForm
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            orders={orders}
            filterOrder={this.getFilteredOrders}
            filteredData={filterData}
            clear={this.removeFilter}
            isMobileFilterSelected={isMobileFilterSelected}
            csvOrders={csvOrders}
            loadCSVOrders={this.loadCSVOrders}
          />
          <MobileListSorter
            isSortSelected={isMobileSortSelected}
            activeSort={activeSort}
            availableSort={avaliableSort}
            changeSortBySelect={this.changeSortBySelect}
          />
          <div className='clearfix' />
          {orders.length > 0 ? (
            <div key={listKey} className='table-box tab-cont sm-height'>
              <InfiniteSccroll
                pageStart={0}
                loadMore={this.loadMoreOrders}
                useWindow={false}
                hasMore={!allOrders}
                loader={
                  <Glyphicon key={0} glyph='refresh' className='spinning' />
                }
              >
                <OrdersList
                  orders={orders}
                  changeSort={this.changeSort}
                  activeSort={activeSort}
                  handleOnClick={this.handleOrderClick}
                />
              </InfiniteSccroll>
            </div>
          ) : (
            <h2>Orders list is empty</h2>
          )}
        </div>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    filterData: state.orders.orderFilters,
    activeFilter: state.orders.activeFilter,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setFilter: data => dispatch(setFilterData(data)),
    activateFilter: data => dispatch(setFilterFlag(data)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Orders);
